<div class="header-dropdown-menu__panel tw-pt-2 tw-min-w-28 tw-overflow-hidden">
  @for (item of items; track item._id) {
    <div class="tw-w-full tw-border-b-2 tw-border-transparent item-wrapper" [class.active-item]="activeItemIds.has(item._id)">
      <app-menu-top-bar-item
        [item]="item"
        [displayMode]="'list'"
        [isActive]="activeItemIds.has(item._id)"
        [routerPath]="routerPaths.get(item._id) ?? null"
        [isCasinoOpened]="isCasinoOpened"
        [isLightTheme]="isLightTheme"
        [isLoggedIn]="isLoggedIn"
        [showThemeTooltip]="false"
        [hideButtonLightMode]="hideButtonLightMode"
        [showCrmButton]="showCrmButton"
        [labelClass]="labelClass"
        [inSubheader]="inSubheader"
        (itemClick)="itemClick.emit($event)"
        (themeToggle)="themeToggle.emit()"
      ></app-menu-top-bar-item>
    </div>
  }
</div>
